// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1oUIQ","title":"ClientInsurance_title__ylX4J","itemText":"ClientInsurance_itemText__1miYb"};